if (!customElements.get('infinite-scroll-pagination')) {
  customElements.define(
    'infinite-scroll-pagination',
    class InfiniteScrollPagination extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.gridId = this.dataset.gridId || 'product-grid';
        this.loading = false;
        this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
          rootMargin: '0px 0px 800px 0px',
        });
      }

      connectedCallback() {
        this.grid = document.getElementById(this.gridId);
        this.paginationWrapper = this.querySelector('.pagination-wrapper');
        this.spinner = this.querySelector('.infinite-scroll-pagination__spinner');
        this.updateNextLink();
        if (!this.nextLink) return;

        if (this.paginationWrapper) this.paginationWrapper.classList.add('visually-hidden');
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer.disconnect();
      }

      updateNextLink() {
        this.nextLink = this.querySelector('a.pagination__item--prev');
      }

      onIntersect(entries) {
        if (this.loading || !entries[0].isIntersecting || !this.nextLink) return;
        this.loadNextPage();
      }

      loadNextPage() {
        this.loading = true;
        if (this.spinner) this.spinner.classList.remove('hidden');

        const url = new URL(this.nextLink.href, window.location.origin);
        url.searchParams.set('section_id', this.sectionId);

        fetch(url.toString())
          .then((response) => response.text())
          .then((text) => {
            const html = new DOMParser().parseFromString(text, 'text/html');
            const newGrid = html.getElementById(this.gridId);
            const newPagination = html.querySelector('infinite-scroll-pagination');

            if (newGrid && this.grid) {
              this.grid.append(...newGrid.children);
              if (typeof window.initializeScrollAnimationTrigger === 'function') {
                window.initializeScrollAnimationTrigger(this.grid);
              }
            }

            this.nextLink = null;
            if (newPagination) {
              const newNextLink = newPagination.querySelector('a.pagination__item--prev');
              if (newNextLink) {
                this.nextLink = newNextLink;
                const newWrapper = newPagination.querySelector('.pagination-wrapper');
                if (this.paginationWrapper && newWrapper) {
                  this.paginationWrapper.replaceWith(newWrapper);
                  this.paginationWrapper = newWrapper;
                  this.paginationWrapper.classList.add('visually-hidden');
                }
              }
            }

            this.loading = false;
            if (this.spinner) this.spinner.classList.add('hidden');

            if (!this.nextLink) this.observer.unobserve(this);
          })
          .catch((e) => {
            console.error(e);
            this.loading = false;
            if (this.spinner) this.spinner.classList.add('hidden');
          });
      }
    }
  );
}
